import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'account',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
